var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('workbench-design-render',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"workbench",class:_vm.scope.clsPrefix,attrs:{"data":_vm.data}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }